import { useCountDown, useMemoizedFn, useSafeState } from "ahooks";

/**
 * 以秒为单位的倒计时，比如发送短信后60秒倒计时
 * @param props.second 自定义倒计时几秒
 * @param props.onEnd 倒计时结束的回调
 */
export function useSecondDown({
  second,
  onEnd,
}: {
  second: number;
  onEnd?: () => void;
}) {
  const [targetDate, setTargetDate] = useSafeState<number>();

  const [countdown] = useCountDown({
    targetDate,
    onEnd,
  });

  const reset = useMemoizedFn(() => {
    setTargetDate(Date.now() + 1000 * second);
  });

  return {
    /**
     * 倒计时秒数
     */
    count: Math.round(countdown / 1000),
    /**
     * 重置倒计时
     */
    reset,
  };
}
